import React from 'react'
import clsx from 'clsx'
import { RatingContext } from '../../utils/RatingContext'
import styles from '../../assets/styles/styles.module.css'
import { TEXT } from '../../i18n/text'
import errorImg from '../../assets/images/userrating-error.jpg'

import { PIcon, PText} from '@porsche-design-system/components-react'

export const RatingError = (): React.ReactElement => {
    const language = React.useContext(RatingContext).language
    const errorCode = React.useContext(RatingContext).errorCode

    return (
        <div className={clsx(styles.content)}>
          <div
            className={clsx( styles.completion, styles.spacingL, styles.completionError )}
            style={{
              backgroundImage: `url("${errorImg}")`
            }}
          />
          <div className={clsx(styles.errorBar)}>
            <PIcon
              name='warning'
              size='small'
              color='inherit'
              style={{ color: '#F1A200' }}
              className={clsx(styles.errorBarIcon)}
            />
            <PText>
              {TEXT[language].error.title} {TEXT[language].error[errorCode]}
            </PText>
          </div>
        </div>
    )
}
